<template>
  <AppBtn class="menu-button flex justify-between items-center px-5 self-end" white block still>
    {{ label }}
    <AppIcon icon="mdi:chevron-down" />
  </AppBtn>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>

<style scoped>
.menu-button {
  width: 100%;
  color: #000;
  border-radius: var(--border-r-sm);
  cursor: pointer;
  border: 1px solid gray;
}
:deep(.v-btn__content) {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center; 
}
:deep(.v-overlay__content) {
  border-radius: var(--border-r-md);
}
@media (min-width: 851px) {
  .menu-button {
    max-width: 360px;
  }
}
@media (max-width: 850px) {
  .menu-button {
    align-self: start;
    width: 70%;
    margin-top: var(--space-5);
  }
}
</style>